<!-- 签署进度展示卡片 -->
<template>
  <Card v-if="schedule && schedule.length">
    <div slot="custom-header" class="custom-header">
      <div class="custom-title">签署进度</div>
      <div style="color: #2761F3; cursor: pointer;">
        <i class="el-icon-refresh-right" style="margin-right: 2px"></i>
        <span @click="handleRefresh">刷新进度</span>
      </div>
    </div>
    <div class="withhold-container">
      <el-timeline>
        <el-timeline-item placement="top" v-for="(item, index) in schedule" :key="index">
          <span>{{ item.signTime }}</span>
          <span>{{ item.content }}</span>
        </el-timeline-item>
      </el-timeline>
    </div>
  </Card>
</template>

<script setup>
const props = defineProps({
  schedule: {
    type: Array,
    default: () => [],
  },
})

const emits = defineEmits(['refresh'])

const handleRefresh = () => {
  emits('refresh')
}
</script>

<style lang="scss" scoped>
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-title {
    line-height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, .9);
  }
}

.withhold-container {
  margin: 0 100px;
}

::v-deep .el-timeline-item__timestamp.is-top {
  padding-top: 0;
}
</style>
